import { isYoutubeHosted, requestMarketingConsent } from '/Foundation/Common/code/Helpers/CookieConsentHelper.ts';

const FALLBACK_TEXTS = {
  title: 'Accept marketing cookies to watch this video',
  text: 'This video is hosted by YouTube, which sets marketing cookies when it loads.',
  button: 'Accept marketing cookies',
};

const getText = (key) => window._THULEDATA?.cookieConsent?.translations?.[key] || FALLBACK_TEXTS[key];

/**
 * <thule-consent-placeholder poster="https://..."></thule-consent-placeholder>
 * Shown in place of a YouTube player until marketing consent exists. The button grants
 * marketing consent; whoever rendered the placeholder swaps it for the player afterwards.
 */
class ConsentPlaceholder extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.classList.add('js-video-placeholder');

    const poster = this.getAttribute('poster')?.trim();
    if (poster && !isYoutubeHosted(poster)) {
      this.style.backgroundImage = `url("${poster}")`;
    }

    const inner = document.createElement('div');
    inner.className = 'consentPlaceholder__inner';

    const title = document.createElement('p');
    title.className = 'consentPlaceholder__title heading6';
    title.textContent = getText('title');

    const text = document.createElement('p');
    text.className = 'consentPlaceholder__text paragraph--s';
    text.textContent = getText('text');

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'btn thule-btn-default btn-sm consentPlaceholder__button';
    button.textContent = getText('button');
    button.addEventListener('click', (event) => {
      event.stopPropagation();
      requestMarketingConsent();
    });

    inner.append(title, text, button);
    this.replaceChildren(inner);
  }
}

if (!customElements.get('thule-consent-placeholder')) {
  customElements.define('thule-consent-placeholder', ConsentPlaceholder);
}

export default ConsentPlaceholder;
